import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { ISISStudent } from '../Models/ISISStudent';

@Injectable()
export class SISStudentService extends BaseService {

  constructor(protected _http: HttpClient) { super(_http); }

  get(url: string): Observable<ISISStudent> {
    return this._http.get<ISISStudent>(url).map((response: ISISStudent) => response as ISISStudent)
      .catch(this.handleError);
  }

}
